import moment from 'moment';
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import CONFIG from 'Config';

import * as SubscriptionActionTypes from './constants';

export function fetchAvailableSubscriptionPlans() {
  console.log('fetchSubscription plans kicked off');
  return () => axios({
    url: `${CONFIG.apiV3Url}/subscription-plans`,
    method: 'GET',
    headers: {
      //'Authorization': 'Bearer ' + window.localStorage.getItem('auth_token')
    },
  });
}

export function fetchShopperSubscriptionPlans() {
  console.log('fetchSubscription plans kicked off');
  return () => axios({
    url: `${CONFIG.apiV3Url}/shopper-subscription-plans`,
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('auth_token')
    },
  });
}


export function updateShopperSubscriptionPlan( subscriptionID ) {
  console.log('updateShopperSubscriptionPlan function in flux roundups actions triggered with selectedPlan subscriptionID: ', subscriptionID);
  return () => axios({
    url: `${CONFIG.apiV3Url}/shopper-subscription-plans`,
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('auth_token')
    },
    data: { "subscription_id": subscriptionID },
  });
}

export function setAvailableSubscriptionPlans(availableSubscriptionPlans) {
  console.log('setAvailableSubscriptionPlans ACTION function kicked off with subscriptionPlans : ', availableSubscriptionPlans);
  return {
    type: SubscriptionActionTypes.SET_AVAILABLE_SUBSCRIPTION_PLANS,
    payload: availableSubscriptionPlans,
  };
}

export function setShopperSubscriptionPlan(subscriptionPlans) {
  console.log('setShopperSubscriptionPlan ACTION function kicked off with subscriptionPlans : ', subscriptionPlans);
  return {
    type: SubscriptionActionTypes.SET_SHOPPER_SUBSCRIPTION_PLAN,
    payload: subscriptionPlans,
  };
}

export function setSelectedSubscriptionPlan(subscriptionPlans) {
  console.log('setSelectedSubscriptionPlan ACTION function kicked off with subscriptionPlans : ', subscriptionPlans);
  return {
    type: SubscriptionActionTypes.SET_SELECTED_SUBSCRIPTION_PLAN,
    payload: subscriptionPlans,
  };
}


